import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const fmt = new Intl.NumberFormat("en", {
	minimumFractionDigits: 1,
	maximumFractionDigits: 1,
});

const Wrapper = styled.span`
	white-space: nowrap;
	margin-right: 0.75rem;
	opacity: ${(props) =>
		props.value < 5 ? "1" : props.value < 10 ? "0.75" : 0.5};
`;

// Based on current assumption, but obviously problematic, as -1 is
// a valid, very bright object.
const NO_VALUE = -1;

/**
 * Renders the orbital regime of a given RSO in a short manner for display.
 */
const RSOBrightness = ({ intrinsic_magnitude, maximum_magnitude }) => {
	return (
		<span>
			<Brightness value={intrinsic_magnitude} label="intr." />
			<Brightness value={maximum_magnitude} label="max." />
		</span>
	);
};

const Brightness = ({ label, value }) => {
	if (value === null || value === undefined || value === NO_VALUE) return null;
	return (
		<Wrapper value={value}>
			{fmt.format(value)}
			{"  "}
			{label}
		</Wrapper>
	);
};

RSOBrightness.propTypes = {
	periapsis: PropTypes.number,
	apoapsis: PropTypes.number,
	period: PropTypes.number,
};

export default RSOBrightness;
